import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import { useState, useEffect } from 'react'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-45px'
const btnIconClass = 'fs-2'

const MODULE_ICONS: Record<string, string> = {
  cursos: '/media/assemp/icon-module-courses.svg',
  financeiro: '/media/assemp/icon-module-financial.svg',
  juridico: '/media/assemp/icon-module-legal.svg',
}

const Navbar = () => {
  const {config} = useLayout()
  const {currentUser} = useAuth()
  const [selectedModule, setSelectedModule] = useState(() => sessionStorage.getItem('selectedModule') || 'cursos')

  useEffect(() => {
    const handleModuleChange = () => {
      setSelectedModule(sessionStorage.getItem('selectedModule') || 'cursos')
    }
    window.addEventListener('selectedModuleChanged', handleModuleChange)
    window.addEventListener('storage', handleModuleChange)
    return () => {
      window.removeEventListener('selectedModuleChanged', handleModuleChange)
      window.removeEventListener('storage', handleModuleChange)
    }
  }, [])
  
  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={btnClass}
        >
          <KTIcon iconName='element-plus' className={btnIconClass} />
        </div>
        <HeaderNotificationsMenu />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div> */}

      {/* User Greeting */}
      {currentUser?.nomeUsuario && (
        <div className={clsx('app-navbar-item align-items-center', itemClass)}>
          <span className='text-gray-700 fw-semibold fs-6 me-2'>
            Olá, {currentUser.nomeUsuario}
          </span>
        </div>
      )}

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img src={toAbsoluteUrl(MODULE_ICONS[selectedModule] || MODULE_ICONS.cursos)} alt='' />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Navbar}
